import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PlayerWrapper from '../../components/Videos/PlayerWrapper';
import DetailsWrapper from '../../components/Videos/DetailsWrapper';
import * as cartoonsActions from '../../actions/cartoonsActions';
import * as audiosActions from '../../actions/audiosActions';
import * as radioActions from '../../actions/radioActions';

class CartoonDetailsPage extends React.Component {
  static propTypes = {
    // Actions
    actions: PropTypes.shape({
      getCartoon: PropTypes.func,
      getCartoonEpisodes: PropTypes.func,
      getCartoonThread: PropTypes.func,
      clearCartoonData: PropTypes.func,
    }).isRequired,

    audiosActions: PropTypes.shape({
      clearAudios: PropTypes.func,
    }).isRequired,

    radioActions: PropTypes.shape({
      clearRadioPlayer: PropTypes.func,
    }).isRequired,


    // Data
    currentLanguage: PropTypes.string.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string,
      state: PropTypes.object,
    }).isRequired,
    cartoonId: PropTypes.number.isRequired,
    cartoonData: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
        PropTypes.bool,
      ])),
    }).isRequired,
    cartoonEpisodes: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
    cartoonThread: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.object,
    }).isRequired,
  };

  constructor() {
    super();

    this.seasonChangeHandler = this.seasonChangeHandler.bind(this);
    this.episodeClickHandler = this.episodeClickHandler.bind(this);
    this.episodeEndedHandler = this.episodeEndedHandler.bind(this);
  }

  componentDidMount() {
    this.props.audiosActions.clearAudios();
    this.props.radioActions.clearRadioPlayer();
    this.props.actions.getCartoon(this.props.cartoonId);
  }

  componentWillUnmount() {
    this.props.actions.clearCartoonData();
  }

  static getDerivedStateFromProps(nextProps) {
    if (nextProps.cartoonData.status !== null) {
      return {
        isThreadFetching: false,
        isCartoonFetching: false,
      };
    }

    return null;
  }

  seasonChangeHandler(e) {
    this.props.actions.getCartoonEpisodes(e.target.value);
  }

  episodeClickHandler(e) {
    this.props.actions.getCartoonThread(e.target.dataset.id);
  }

  episodeEndedHandler() {
    const { cartoonThread } = this.props;
    const nextEpisode = cartoonThread.data && cartoonThread.data.next && cartoonThread.data.next.media;

    if (nextEpisode) {
      this.props.actions.getCartoonThread(nextEpisode);
    }
  }

  render() {
    // TODO: favorite button
    const {
      currentLanguage,
      cartoonData,
      cartoonEpisodes,
      cartoonThread,
      hasVoucher,
    } = this.props;

    return (
      <React.Fragment>
        <PlayerWrapper
          currentLanguage={currentLanguage}
          hasVoucher={hasVoucher}
          location={this.props.location}
          videoDetails={cartoonData}
          videoEpisodes={cartoonEpisodes}
          episodeThread={cartoonThread}
          selectHandler={this.seasonChangeHandler}
          episodeClickHandler={this.episodeClickHandler}
          episodeEndedHandler={this.episodeEndedHandler}
        />

        <DetailsWrapper
          currentLanguage={currentLanguage}
          videoDetails={cartoonData}
        />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    currentLanguage: state.i18n.currentLanguage,
    cartoonId: parseInt(ownProps.match.params.id, 10),
    cartoonData: state.cartoons.cartoon,
    cartoonEpisodes: state.cartoons.episodes,
    cartoonThread: state.cartoons.cartoonThread,
    hasVoucher: state.user.hasVoucher,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(cartoonsActions, dispatch),
    audiosActions: bindActionCreators(audiosActions, dispatch),
    radioActions: bindActionCreators(radioActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CartoonDetailsPage);
